import React from "react";

interface LandingProps {
  onContinue: () => void;
}

const Landing: React.FC<LandingProps> = ({ onContinue }) => {
  return (
    <div className="min-h-dvh flex flex-col bg-base-100">
      {/* Hero Section */}
      <div className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        <div className="mb-8 animate-bounce">
          <div className="w-20 h-20 bg-primary rounded-2xl flex items-center justify-center shadow-lg rotate-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-primary-content" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        </div>
        
        <h1 className="text-4xl font-black tracking-tight mb-4">
          TPP <span className="text-primary">Traçabilité</span>
        </h1>
        
        <p className="text-lg text-base-content/70 max-w-xs mb-10">
          Photographiez les étiquettes de vos produits : l'envoi dans OneDrive se fait tout seul.
        </p>

        <div className="grid grid-cols-1 gap-4 w-full max-w-xs">
          <div className="flex items-center gap-4 text-left p-3 bg-base-200 rounded-xl">
            <div className="bg-success/20 text-success p-2 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <div>
              <div className="font-bold">Rapide</div>
              <div className="text-xs opacity-60">Une photo après l'autre, sans attendre</div>
            </div>
          </div>
          
          <div className="flex items-center gap-4 text-left p-3 bg-base-200 rounded-xl">
            <div className="bg-info/20 text-info p-2 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div>
              <div className="font-bold">Hors-ligne</div>
              <div className="text-xs opacity-60">Fonctionne sans connexion</div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Action */}
      <div className="p-6 pb-12">
        <button 
          className="btn btn-primary btn-lg btn-block shadow-lg"
          onClick={onContinue}
        >
          Commencer
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Landing;
